(() => {
  'use strict';
  const root = document.querySelector('.fmcg-redesign');
  if (!root) return;
  const config = JSON.parse(document.querySelector('#fmcg-redesign-data').textContent);
  const photos = config.photos;
  const words = config.strings;
  const params = new URLSearchParams(location.search);
  const allowTypes = {tubes:'Paper Tube',jars:'Glass Jar',boxes:'Paper Box',other:'Other'};
  const attributionKeys = ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','utm_id','fbclid'];
  const FT = window.fmcgFT;
  attributionKeys.forEach(key => { const value=params.get(key); if(value && value.length<=500 && !value.includes('{{')) { try { FT?.set(key,value); } catch (_) {} } });
  try { FT?.set('first_landing_page', location.pathname); FT?.set('first_referrer',document.referrer || ''); } catch (_) {}
  function tracked(href) {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin) return href;
    attributionKeys.forEach(key => { let value=''; try {value=FT?.get(key)||'';}catch(_){} value=value||params.get(key)||'';if(value && value.length<=500 && !value.includes('{{') && !url.searchParams.has(key))url.searchParams.set(key,value); });
    if(config.previewTheme)url.searchParams.set('preview_theme_id',config.previewTheme);
    return url.pathname+url.search+url.hash;
  }
  function internalLinks(scope=document) {
    scope.querySelectorAll('a[href^="/"]').forEach(a=>{a.href=tracked(a.getAttribute('href'));});
  }
  function quoteEntry(format,quantity) {
    const url=new URL('/pages/custom-quote',location.origin);
    if(allowTypes[format])url.searchParams.set('selectYour',allowTypes[format]);
    return tracked(url.href);
  }
  function starterRoute(format,quantity) {
    if(quantity==='unknown')return {href:'/?view=fmcg-contact',label:words.unknown,note:words.unknownNote};
    if(quantity==='sub10k')return format==='pouches'?{href:quoteEntry(format,quantity),label:words.quick,note:words.quickNote}:{href:'/?view=fmcg-contact',label:words.small,note:words.smallNote};
    return {href:quoteEntry(format,quantity),label:words.custom,note:words.customNote};
  }
  function bindStarter() {
    const form=document.querySelector('#starter'); if(!form || form.dataset.bound)return;form.dataset.bound='true';
    const getRoute=()=>{const values=new FormData(form);return starterRoute(values.get('format'),values.get('quantity'));};
    const sync=()=>{const r=getRoute();form.querySelector('#starter-label').textContent=r.label;form.querySelector('#route-note').textContent=r.note;form.querySelector('#starter-secondary').hidden=!r.secondary;};
    form.addEventListener('change',sync);form.addEventListener('submit',event=>{event.preventDefault();location.assign(tracked(getRoute().href));});sync();
  }
  function bindQuoteRedirect() {
    if(document.querySelector('#quote-redirect'))location.replace(quoteEntry(params.get('format')));
  }
  let currentPhoto=0,photoTrigger=null,photoSet=photos;
  const dialog=document.querySelector('#photo-viewer');
  function showPhoto(index,trigger,pool) {
    if(pool)photoSet=pool;currentPhoto=(index+photoSet.length)%photoSet.length;
    const photo=photoSet[currentPhoto],image=document.querySelector('#viewer-image');image.src=photo[0];image.alt=photo[2];
    document.querySelector('#photo-caption').textContent=photo[1];document.querySelector('#photo-count').textContent=words.count.replace('{current}',currentPhoto+1).replace('{total}',photoSet.length);
    if(!dialog.open){photoTrigger=trigger;dialog.showModal();document.querySelector('.viewer-close').focus();}
  }
  document.addEventListener('click',event=>{const trigger=event.target.closest('[data-photo]');if(trigger){let pool=photos;const heroData=document.querySelector('#hero-photo-data');if(trigger.classList.contains('hero-expand') && heroData)pool=JSON.parse(heroData.textContent);showPhoto(Number(trigger.dataset.photo),trigger,pool);}});
  document.querySelector('.viewer-close').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>photoTrigger?.focus());
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();showPhoto(currentPhoto+(event.key==='ArrowRight'?1:-1));}});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close();}});
  document.querySelector('#photo-prev').addEventListener('click',()=>showPhoto(currentPhoto-1));document.querySelector('#photo-next').addEventListener('click',()=>showPhoto(currentPhoto+1));
  const menu=document.querySelector('.menu-toggle'),panel=document.querySelector('#mobile-menu');
  menu.addEventListener('click',()=>{const open=menu.getAttribute('aria-expanded')!=='true';menu.setAttribute('aria-expanded',String(open));menu.setAttribute('aria-label',open?words.closeMenu:words.openMenu);panel.hidden=!open;});
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden){panel.hidden=true;menu.setAttribute('aria-expanded','false');menu.setAttribute('aria-label',words.openMenu);menu.focus();}});
  let observer;
  function init() {
    bindHero();bindStarter();bindQuoteRedirect();internalLinks();observer?.disconnect();
    const target=document.querySelector('#hero-quote, #fh-cta'),sticky=document.querySelector('.sticky-quote');sticky.hidden=true;
    if(target && 'IntersectionObserver' in window){observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;});observer.observe(target);}
  }
  function bindHero(){
 const stage=document.querySelector('#hero-stage');if(!stage || stage.dataset.bound)return;stage.dataset.bound='true';const heroData=document.querySelector('#hero-photo-data');const photos=heroData?JSON.parse(heroData.textContent):config.photos;
 let selected=0,touchStart=null;
 const thumbs=[...document.querySelectorAll('[data-hero-photo]')];
 const selectPhoto=(index,focus=false)=>{
  selected=(index+photos.length)%photos.length;
  const photo=photos[selected],img=document.querySelector('#hero-image');
  img.src=photo[0];img.alt=photo[2];
  document.querySelector('#hero-caption').textContent=photo[1];
  document.querySelector('.hero-expand').dataset.photo=String(selected);
  thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-pressed',String(i===selected)));
  if(focus)thumbs[selected].focus();
 };
 thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>selectPhoto(i)));
 document.querySelector('#hero-prev').addEventListener('click',()=>selectPhoto(selected-1));
 document.querySelector('#hero-next').addEventListener('click',()=>selectPhoto(selected+1));
 document.querySelector('.hero-thumbs').addEventListener('keydown',e=>{
  const keys=['ArrowLeft','ArrowRight','Home','End'];if(!keys.includes(e.key))return;
  e.preventDefault();selectPhoto(e.key==='Home'?0:e.key==='End'?photos.length-1:selected+(e.key==='ArrowRight'?1:-1),true);
 });
 stage.addEventListener('touchstart',e=>{touchStart=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;},{passive:true});
 stage.addEventListener('touchend',e=>{if(!touchStart||!e.changedTouches.length)return;const dx=e.changedTouches[0].clientX-touchStart.x,dy=e.changedTouches[0].clientY-touchStart.y;touchStart=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5)selectPhoto(selected+(dx<0?1:-1));},{passive:true});
 selectPhoto(0);stage.addEventListener('touchcancel',()=>{touchStart=null;},{passive:true});
}
  init();document.addEventListener('shopify:section:load',init);
})();

/* Hybrid additions (WEBSITE-REDESIGN B8, 2026-10-13): the hero's two-tap qualifier and the quote
   sheet's one animation. Routing rule: Quick Order prices pouches only (T2 LOCKED-FACTS), so only
   Pouches + Under 10,000 goes there; the quote form gates other formats itself. Works without JS:
   the form submits to the quote page and the bars render at full width. */
(function () {
  var spread = document.getElementById('fh-spread');
  if (spread) {
    var num = document.getElementById('fh-gapnum'), gap = parseInt(num.textContent, 10) || 0;
    var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var run = function () {
      spread.classList.add('in');
      if (reduce) return;
      var t0 = performance.now();
      (function tick(t) { var p = Math.min(1, (t - t0) / 900); num.textContent = Math.round(gap * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(tick); })(t0);
    };
    if ('IntersectionObserver' in window && !reduce) {
      num.textContent = '0';
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.35 });
      io.observe(spread);
    } else run();
  }
  var form = document.getElementById('fh-quote');
  if (!form) return;
  var note = document.getElementById('fh-route-note'), cta = document.getElementById('fh-cta'), label = cta.querySelector('span');
  var pick = { product: 'pouches', units: '10k-50k' };
  var map = { pouches: 'Plastic Mylar Bag', boxes: 'Paper Box', tubes: 'Paper Tube', jars: 'Glass Jar' };
  var sync = function () {
    var quick = pick.units === 'sub10k' && pick.product === 'pouches';
    form.action = quick ? form.dataset.quickUrl : form.dataset.quoteUrl;
    label.textContent = quick ? form.dataset.quickLabel : form.dataset.quoteLabel;
    note.innerHTML = quick ? form.dataset.quickNote : form.dataset.quoteNote;
    var sel = form.querySelector('input[name="selectYour"]');
    sel.value = map[pick.product] || '';
    sel.disabled = quick || !sel.value;
  };
  [].forEach.call(form.querySelectorAll('.chips'), function (g) {
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.chip'); if (!b) return;
      [].forEach.call(g.querySelectorAll('.chip'), function (c) { c.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true'); pick[g.dataset.group] = b.dataset.v; sync();
    });
  });
  sync();
})();
